import { combineReducers } from 'redux';
import documentReducer from './documentReducer'; // Create this reducer

const rootReducer = combineReducers({
  documents: documentReducer,
  // add other reducers here
});

export default rootReducer;
